var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageContent',[_c('template',{slot:"heading-title"},[_vm._v("Outdoor mobile coverage map")]),_vm._v(" "),_c('div',{staticClass:"map",attrs:{"slot":"content"},slot:"content"},[_c('div',{staticClass:"menu-container"},[_c('Menu')],1),_vm._v(" "),_c('div',{staticClass:"map-container"},[_c('CustomMap')],1),_vm._v(" "),_c('MessageModal')],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4221ff2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/MapPage.vue
// module id = null
// module chunks = 